module.exports = __webpack_public_path__ + "static/img/search.2328b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/search.png
// module id = Jloj
// module chunks = 36